export const parseQueryParameterIntegerArray = (params: any[]): number[] => {
  return params.map((p) => parseInt(p, 10)).filter((p) => !!p)
}
